import { createFileRoute } from '@tanstack/react-router'

import { FeatureAdoptionScreen } from './-components/feature-adoption-screen.tsx'

export const Route = createFileRoute('/business-performance/feature-adoption')({
  component: FeatureAdoptionScreen
})
